import React, { useState, useEffect } from 'react';
import MessageSideBar from '../components/message_side_bar.tsx';
import ChatInterface from '../components/chat_interface.tsx';
import { useRecruiter } from '../context/RecruiterContext.tsx';

const ChatPage: React.FC = () => {
    const [conversations, setConversations] = useState([]);
    const [messages, setMessages] = useState<any[]>([]);
    const [selectedConversationId, setSelectedConversationId] = useState<string | null>(null);
    const r = useRecruiter()
    useEffect(() => {
        // Fetch conversations when the component mounts
        const fetchConversations = async () => {
            try {
                const response = await fetch('/api/message/conversations'); // Replace with actual user ID
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setConversations(data);
            } catch (error) {
                console.error('Error fetching conversations:', error);
            }
        };

        fetchConversations();
    }, []);

    useEffect(() => {
        // Fetch messages when a conversation is selected
        if (selectedConversationId) {
            const fetchMessages = async () => {
                try {
                    const response = await fetch(`/api/message/messages?conversation_id=${selectedConversationId}`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const data = await response.json();
                    setMessages(data);
                } catch (error) {
                    console.error('Error fetching messages:', error);
                }
            };

            fetchMessages();
        }
    }, [selectedConversationId]);

    const handleSelectConversation = (id: string) => {
        setSelectedConversationId(id);
    };

    const handleSendMessage = async (text: string) => {
        if (!selectedConversationId) return;

        try {
            const response = await fetch('/api/message', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    action: 'add_message',
                    conversation_id: selectedConversationId,
                    sender_id: r.userId, // Replace with the actual user ID
                    text,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const newMessage = await response.json();
            setMessages([...messages, newMessage]);
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    return (
        <div className="flex h-screen">
            <MessageSideBar
                conversations={conversations}
                onSelectConversation={handleSelectConversation}
                selectedConversationId={selectedConversationId}
            />
            <ChatInterface
                messages={messages}
                onSendMessage={handleSendMessage}
            />
        </div>
    );
};

export default ChatPage;